


































































import { InboxNotification } from '@/models/inbox-notification';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { notificationService } from '@/services/notification-service';
import Toast from './toast.vue';

@Component
export default class NotificationsSidebar extends Vue {
	@Prop()
	public inboxNotifications!: InboxNotification[];

	@Watch('inboxNotifications', { immediate: true })
	public onNotificationsUpdated() {
		notificationService.addProductInfoToNotifications();
	}

	public get smallScreen(): boolean {
		return window.innerWidth < 992;
	}

	public async retryNotification(notification: InboxNotification): Promise<void> {
		await notificationService.retryNotification(notification);
		await this.dismissNotification(notification); // Dismiss the notification since if it fails again it'll end up back here anyway.
		this.createToast(
			'Job has been put back on to the retry queue, check back here in ~10 minutes to verify it was successful',
		);
	}

	public async dismissNotification(notification: InboxNotification): Promise<void> {
		await notificationService.dismissNotification(notification.id);
	}

	private createToast(message: string) {
		new Toast().makeToast(message, '', 'success', false);
	}
}
